import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import VueApexCharts from 'vue3-apexcharts'
import ApexCharts from 'apexcharts'
import App from './App.vue'
import router from './router'
import i18n from './plugins/i18n'
import './styles/index.css'

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

app.use(pinia)
app.use(router)
app.use(i18n)
app.use(VueApexCharts)

app.mount('#app')

app.config.globalProperties.$apexcharts = ApexCharts

declare module 'vue' {
  interface ComponentCustomProperties {
    $apexcharts: typeof ApexCharts
  }
}
